import React from 'react';
import { useTranslation } from 'react-i18next';

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();
  
  const languages = [
    { code: 'en', name: 'English', flag: '🇺🇸' },
    { code: 'de', name: 'Deutsch', flag: '🇩🇪' },
    { code: 'fr', name: 'Français', flag: '🇫🇷' },
    { code: 'es', name: 'Español', flag: '🇪🇸' },
    { code: 'it', name: 'Italiano', flag: '🇮🇹' },
    { code: 'nl', name: 'Nederlands', flag: '🇳🇱' },
    { code: 'pl', name: 'Polski', flag: '🇵🇱' },
    { code: 'sv', name: 'Svenska', flag: '🇸🇪' },
    { code: 'da', name: 'Dansk', flag: '🇩🇰' },
    { code: 'pt', name: 'Português', flag: '🇵🇹' },
    { code: 'fi', name: 'Suomi', flag: '🇫🇮' },
    { code: 'el', name: 'Ελληνικά', flag: '🇬🇷' },
    { code: 'cs', name: 'Čeština', flag: '🇨🇿' }
  ];

  const handleLanguageChange = (newLanguage) => {
    try {
      // Change i18n language
      i18n.changeLanguage(newLanguage);
      
      // Update URL
      const currentPath = window.location.pathname;
      const pathSegments = currentPath.split('/').filter(Boolean);
      const supportedLanguages = ['en', 'de', 'fr', 'es', 'it', 'pl', 'sv', 'da', 'pt', 'fi', 'el', 'cs', 'nl'];
      
      let newPath;
      if (pathSegments.length > 0 && supportedLanguages.includes(pathSegments[0])) {
        // Replace existing language
        pathSegments[0] = newLanguage;
        newPath = '/' + pathSegments.join('/');
      } else {
        // Add language to path
        newPath = `/${newLanguage}${currentPath === '/' ? '' : currentPath}`;
      }
      
      // Update URL without page reload
      if (newPath !== currentPath && newPath.startsWith('/') && !newPath.includes('..')) {
        window.history.pushState({}, '', newPath);
      }
      
      // Store language preference
      try {
        localStorage.setItem('i18nextLng', newLanguage);
      } catch (e) {
        console.warn('Could not save language preference:', e);
      }
      
      console.log(`[LanguageSwitcher] Changed language to: ${newLanguage}`);
    } catch (error) {
      console.error('Error changing language:', error);
    }
  };

  return (
    <div className="relative inline-block text-left">
      <select 
        value={i18n.language}
        onChange={(e) => handleLanguageChange(e.target.value)}
        className="bg-white border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 cursor-pointer"
      >
        {languages.map((lang) => (
          <option key={lang.code} value={lang.code}>
            {lang.flag} {lang.name}
          </option>
        ))}
      </select>
    </div>
  );
};

export default LanguageSwitcher;